import React from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {deleteUser, cancelDeleteUser} from "../../vendors/actions/user";

interface OwnProps {

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    deleteUser: () => void,
    cancelDeleteUser: (data: any) => void,
}

const DeleteUser = (props: any) => {
    const {Modals: ModalActions} = props;
    const {userDelete} = ModalActions;

    const deleteUser = () => {
        props.deleteUser();
    };

    const cancelCaseModal = () => {
        props.cancelDeleteUser(false);
    };


    return userDelete ? (
        <Modals.Danger title={'Are you sure you want to delete your account?'}
                       open={userDelete}
                       cancelable={{
                           buttonTitle: 'Never Mind',
                           action: cancelCaseModal
                       }}
                       submit={{
                           buttonTitle: 'Delete',
                           action: deleteUser
                       }}
                       icon={'times'}
                       mainBtnColor='secondary'
                       secondaryBtnColor='secondary'
        />
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals} = state;
    return {
        Modals,
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        deleteUser: () => dispatch(deleteUser()),
        cancelDeleteUser: (data: any) => dispatch(cancelDeleteUser(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUser);


